var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.262,
    height: 23.227,
    viewBox: "0 0 19.262 23.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27385",
    "data-name": "Caminho 27385",
    d: "M161.614,41.361a3.187,3.187,0,0,0-1.053,6.215v2.9a3.687,3.687,0,0,1-7.374,0V46.259a6.583,6.583,0,0,0,5.557-6.5V37.305a2.37,2.37,0,0,0-2.37-2.37h-.105v-.843a1.053,1.053,0,1,0-2.107,0v3.792a1.053,1.053,0,1,0,2.107,0v-.843h.105a.263.263,0,0,1,.263.263v2.449a4.477,4.477,0,0,1-8.927,0V37.305a.263.263,0,0,1,.263-.263h.105v.843h0a1.053,1.053,0,1,0,2.107,0V34.093a1.053,1.053,0,0,0-2.107,0v.843h-.105a2.37,2.37,0,0,0-2.37,2.37v2.449a6.583,6.583,0,0,0,5.477,6.478v4.24a5.794,5.794,0,0,0,11.587,0v-2.9a3.187,3.187,0,0,0-1.054-6.215Zm0,4.293a1.08,1.08,0,1,1,.764-.316A1.08,1.08,0,0,1,161.614,45.653Z",
    transform: "translate(-145.603 -33.039)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.34a165aab9782fd894f89588be4b2ef3.svg";
export { ForwardRef as ReactComponent };